export default function ErrorBox({ error }) {
  return (
    <div className={`error-box error-box--${error.type}`}>
      <div className="error-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="8" x2="12" y2="12"/>
          <line x1="12" y1="16" x2="12.01" y2="16"/>
        </svg>
      </div>
      <div className="error-body">
        <p className="error-title">{error.title}</p>
        <p className="error-message">{error.message}</p>
        <div className="error-actions">
          {error.action && (
            <a href={error.action.href} className="error-action-link">
              {error.action.label}
            </a>
          )}
          {error.support && (
            <a href="mailto:support@membify.dk" className="error-support-link">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              Kontakt support
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
